import React from 'react';
import WorkerAnt from './images/WorkForce.png';
import Tooltip from './Tooltip';

function LeveledAntStats({
  level,
  remainPotions,
  levelGroundRemainPotions,
  levelGroundUpdatedTimeString,
  isLoading,
  address
}) {

  const formatAddress = (address) => {
    return address ? `${address.substring(0, 6)}...${address.substring(address.length - 6)}` : '';
  };

  // Function to copy the full address to the clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      // Here you could include some feedback to the user, such as a toast notification
      alert('Address copied to clipboard!'); // Placeholder feedback
    }, (err) => {
      console.error('Failed to copy address', err);
    });
  };

  return (
    <div className="left-content">
      <div className={`Ant-class`}>
        <h1>Worker ANT</h1>
        <div className="class-image">
          <img src={WorkerAnt} alt="Worker ANT" />
        </div>
      </div>
      <p style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(address)}>
        {formatAddress(address)}
      </p>
      <div className="level-container">
        <div className="level">
          <h2>{isLoading ? 'N/A' : level || 'N/A'}</h2> 
        </div>
        <div className="experience">
          <h2>{isLoading ? ' N/A ' : level === 40 ? 'MAX' : `${remainPotions || 0}/ ${level + 1}`}</h2>
          <Tooltip text="Ant's level and experience"></Tooltip>
        </div>
      </div>
      <div className="divider" id="stats-divider"></div>
    </div>
  );
}

export default LeveledAntStats;